// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { FileFragment } from './FileFragment.generated';
import { gql } from '@apollo/client';
import { FileFragmentDoc } from './FileFragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UploadFileV2MutationVariables = Types.Exact<{
  input: Types.CreateFileInput;
  upload: Types.Scalars['Upload']['input'];
}>;


export type UploadFileV2Mutation = { __typename?: 'Mutation', uploadFileV2: (
    { __typename?: 'File' }
    & FileFragment
  ) };

export type UploadCsvImportFileV2MutationVariables = Types.Exact<{
  input: Types.CreateFileInput;
  upload: Types.Scalars['Upload']['input'];
}>;


export type UploadCsvImportFileV2Mutation = { __typename?: 'Mutation', uploadFileV2: (
    { __typename?: 'File' }
    & FileFragment
  ) };

export type UploadPlatformFileMutationVariables = Types.Exact<{
  input: Types.CreateFileInput;
  upload: Types.Scalars['Upload']['input'];
}>;


export type UploadPlatformFileMutation = { __typename?: 'Mutation', uploadFileV2: { __typename?: 'PlatformFile', id: string } };

export const Operations = {
  Mutation: {
    UploadFileV2: 'UploadFileV2' as const,
    UploadCSVImportFileV2: 'UploadCSVImportFileV2' as const,
    UploadPlatformFile: 'UploadPlatformFile' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const UploadFileV2Document = gql`
    mutation UploadFileV2($input: CreateFileInput!, $upload: Upload!) {
  uploadFileV2(input: $input, upload: $upload) {
    ...File
  }
}
    ${FileFragmentDoc}`;
export type UploadFileV2MutationFn = Apollo.MutationFunction<UploadFileV2Mutation, UploadFileV2MutationVariables>;

/**
 * __useUploadFileV2Mutation__
 *
 * To run a mutation, you first call `useUploadFileV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFileV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFileV2Mutation, { data, loading, error }] = useUploadFileV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *      upload: // value for 'upload'
 *   },
 * });
 */
export function useUploadFileV2Mutation(baseOptions?: Apollo.MutationHookOptions<UploadFileV2Mutation, UploadFileV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadFileV2Mutation, UploadFileV2MutationVariables>(UploadFileV2Document, options);
      }
export type UploadFileV2MutationHookResult = ReturnType<typeof useUploadFileV2Mutation>;
export type UploadFileV2MutationResult = Apollo.MutationResult<UploadFileV2Mutation>;
export type UploadFileV2MutationOptions = Apollo.BaseMutationOptions<UploadFileV2Mutation, UploadFileV2MutationVariables>;
export const UploadCsvImportFileV2Document = gql`
    mutation UploadCSVImportFileV2($input: CreateFileInput!, $upload: Upload!) {
  uploadFileV2: uploadCSVImportFileV2(input: $input, upload: $upload) {
    ...File
  }
}
    ${FileFragmentDoc}`;
export type UploadCsvImportFileV2MutationFn = Apollo.MutationFunction<UploadCsvImportFileV2Mutation, UploadCsvImportFileV2MutationVariables>;

/**
 * __useUploadCsvImportFileV2Mutation__
 *
 * To run a mutation, you first call `useUploadCsvImportFileV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadCsvImportFileV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadCsvImportFileV2Mutation, { data, loading, error }] = useUploadCsvImportFileV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *      upload: // value for 'upload'
 *   },
 * });
 */
export function useUploadCsvImportFileV2Mutation(baseOptions?: Apollo.MutationHookOptions<UploadCsvImportFileV2Mutation, UploadCsvImportFileV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadCsvImportFileV2Mutation, UploadCsvImportFileV2MutationVariables>(UploadCsvImportFileV2Document, options);
      }
export type UploadCsvImportFileV2MutationHookResult = ReturnType<typeof useUploadCsvImportFileV2Mutation>;
export type UploadCsvImportFileV2MutationResult = Apollo.MutationResult<UploadCsvImportFileV2Mutation>;
export type UploadCsvImportFileV2MutationOptions = Apollo.BaseMutationOptions<UploadCsvImportFileV2Mutation, UploadCsvImportFileV2MutationVariables>;
export const UploadPlatformFileDocument = gql`
    mutation UploadPlatformFile($input: CreateFileInput!, $upload: Upload!) {
  uploadFileV2: uploadPlatformFile(input: $input, upload: $upload) {
    id
  }
}
    `;
export type UploadPlatformFileMutationFn = Apollo.MutationFunction<UploadPlatformFileMutation, UploadPlatformFileMutationVariables>;

/**
 * __useUploadPlatformFileMutation__
 *
 * To run a mutation, you first call `useUploadPlatformFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadPlatformFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadPlatformFileMutation, { data, loading, error }] = useUploadPlatformFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *      upload: // value for 'upload'
 *   },
 * });
 */
export function useUploadPlatformFileMutation(baseOptions?: Apollo.MutationHookOptions<UploadPlatformFileMutation, UploadPlatformFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadPlatformFileMutation, UploadPlatformFileMutationVariables>(UploadPlatformFileDocument, options);
      }
export type UploadPlatformFileMutationHookResult = ReturnType<typeof useUploadPlatformFileMutation>;
export type UploadPlatformFileMutationResult = Apollo.MutationResult<UploadPlatformFileMutation>;
export type UploadPlatformFileMutationOptions = Apollo.BaseMutationOptions<UploadPlatformFileMutation, UploadPlatformFileMutationVariables>;